// Webpack Imports
import 'bootstrap';


( function ( $ ) {
	'use strict';
	$( '.scrollto' ).on( 'click', function ( e ) {
		var anchor = $( this ).data('anchor');
		console.log(anchor)
		if ( $('#' + anchor ).length ) {
			$("html, body").animate({scrollTop: $('#' + anchor).offset().top}, 1000, "swing");
			if ($('body').hasClass('modal-open')) {
				$('.btn-bars').click()
			}
	    return false
		} else {
			return true
		}
	});
	$('.btn-bars').on('click', function(){
		console.log('click')
		if ($('body').hasClass('is-animating')) {
			return false;
		}
		$('body').addClass('is-animating')
		$('body').toggleClass('modal-open menu-open')
		$(this).toggleClass('is-open')
		setTimeout(function(){
			if ($('body').hasClass('menu-open')) {
				$('.modal-bg').css({'top': 0, 'bottom': 'inherit'});
			}
			else {
				$('.modal-bg').css({'top': 'inherit', 'bottom': 0});
			}
			$('body').removeClass('is-animating')				
		}, 650);
		return false;
	})
}( jQuery ) );
